import {
  DotsVertical,
  Trash,
} from "@lazarentertainment/web-design-system/components/iconOutline"
import {
  MenuButtonContent,
  MenuButtonGroup,
  MenuButtonItem,
  MenuButtonRoot,
  MenuButtonTrigger,
} from "@lazarentertainment/web-design-system/components/menuButton"
import { Spinner } from "@lazarentertainment/web-design-system/components/spinner"
import { Truncate } from "@lazarentertainment/web-design-system/components/truncate"
import ImagePlaceholder from "assets/icons/imagePlaceholder.svg"
import { Button } from "client/designSystem/Button"
import { MenuButtonPortalWithFullscreenAwareness } from "client/designSystem/FullscreenAwarePortals"
import NumberInput from "client/designSystem/NumberInput"

import { Price } from "../ui/priceComponents/Price"
import { SoldOut } from "../ui/priceComponents/SoldOut"

import styles from "./ProductTile.module.css"

export type ProductCartTileProps = {
  title: string
  description?: string

  price: string
  compareAtPrice?: string
  priceCurrencyCode: string

  imageUrl?: string
  soldOut?: boolean

  quantity: string

  loading: boolean
  removeItem: () => void
  handleChange: (newValue: string) => void
  handleBlur?: () => void
}

export const ProductCartTile = ({
  title,
  description,
  price,
  compareAtPrice,
  priceCurrencyCode,
  imageUrl,
  soldOut = false,

  quantity,

  loading,
  removeItem,
  handleChange,
  handleBlur,
}: ProductCartTileProps) => {
  return (
    <div className={styles.productCartTile}>
      <div className={styles.productTileImageContainer}>
        {imageUrl ? (
          <img
            className={styles.productTileImage}
            src={imageUrl}
            alt={title}
            width={100}
            height={100}
          />
        ) : (
          <ImagePlaceholder />
        )}
      </div>
      <div className={styles.productCartTileRightSection}>
        <div className={styles.productCartTileTitleSection}>
          <Truncate
            lineCount={2}
            className={`${styles.productTileTitle} title-sm`}
          >
            {title}
          </Truncate>
          {description && (
            <Truncate
              lineCount={1}
              className="body-md text-color-secondary-subdued"
            >
              {description}
            </Truncate>
          )}
        </div>
        <div className={styles.productTileBottomRow}>
          {loading && <Spinner />}
          {!loading && !soldOut && (
            <Price
              size="sm"
              amount={price}
              compareAtAmount={compareAtPrice}
              currencyCode={priceCurrencyCode}
            />
          )}
          {!loading && soldOut && <SoldOut size="sm" />}

          <div className={styles.productTileActionRow}>
            <NumberInput
              variant="compact"
              label="quantity"
              value={quantity}
              handleChange={handleChange}
              onBlur={handleBlur}
              showTrashIconOnOneRemaining
            />

            <MenuButtonRoot>
              <MenuButtonTrigger asChild>
                <Button
                  variant="tertiary-gray"
                  size="md"
                  icon={DotsVertical}
                  iconOnly
                  data-robot="cart-item-menu-button"
                />
              </MenuButtonTrigger>
              <MenuButtonPortalWithFullscreenAwareness>
                <MenuButtonContent>
                  <MenuButtonGroup>
                    <MenuButtonItem
                      data-variant="destructive"
                      onSelect={removeItem}
                      data-robot="cart-item-remove"
                    >
                      <Trash />
                      Remove from cart
                    </MenuButtonItem>
                  </MenuButtonGroup>
                </MenuButtonContent>
              </MenuButtonPortalWithFullscreenAwareness>
            </MenuButtonRoot>
          </div>
        </div>
      </div>
    </div>
  )
}
